"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopperMenu = PopperMenu;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function PopperMenu(_ref) {
  var anchorRef = _ref.anchorRef,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-end' : _ref$placement,
    onClose = _ref.onClose,
    children = _ref.children;
  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    onClose();
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Popper, {
    open: true,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    disablePortal: true,
    placement: placement
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps,
      placement = _ref2.placement;
    return /*#__PURE__*/_react["default"].createElement(_material.Grow, Object.assign({}, TransitionProps, {
      style: {
        transformOrigin: placement
      }
    }), /*#__PURE__*/_react["default"].createElement(_material.Paper, {
      sx: {
        maxHeight: "calc(110vh - 120px)",
        overflowY: 'auto'
      }
    }, /*#__PURE__*/_react["default"].createElement(_material.ClickAwayListener, {
      onClickAway: handleClose
    }, children)));
  });
}